import { createSelector } from 'reselect';

import { IKnmReasonTypeExtended } from 'APIPackage/CatalogsModule/interfaces/IKnmReasonTypeExtended';
import { CommonCatalogsNamesEnum } from 'CorePackage/CatalogsModule/enums/CommonCatalogsNamesEnum';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { IFetchKnmSupervisionTypesByKnmTypeAndSubjectType } from 'APIPackage/CatalogsModule/services/knmSupervisionTypesApi';
import { excludeGeneralOptions } from 'CorePackage/MainModule/common/excludeGeneralOptions';
import { IYearSelectOption } from 'CorePackage/MainModule/interfaces/IYearSelectOption';
import { IKnmStatus } from 'APIPackage/CatalogsModule/interfaces/IKnmStatus';
import { createViolationMaterialTypeSelectOption } from 'CorePackage/CatalogsModule/common/createViolationMaterialTypeSelectOption';
import { createViolationFixMethodSelectOption } from 'CorePackage/CatalogsModule/common/createViolationFixMethodSelectOption';
import { createViolationFixGradeSelectOption } from 'CorePackage/CatalogsModule/common/createViolationFixGradeSelectOption';
import { DictionaryNamesEnum } from 'CorePackage/DictionariesModule/enums/DictionaryNamesEnum';
import { IDictionarySupervisionTypeSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySupervisionTypeSelectOption';

import { IRolesSelectOption } from '../interfaces/IRoleSelectOption';
import { ComplexCatalogsNamesEnum } from '../enums/ComplexCatalogsNamesEnum';
import { ICommonCatalogsState } from '../interfaces/ICommonCatalogsState';
import { createChecklistAnswerTypeSelectOption } from '../common/createChecklistAnswerTypeSelectOption';
import { createKnmExpertTypeSelectOption } from '../common/createKnmExpertTypeSelectOption';
import { createKnmAddressTypeSelectOption } from '../common/createKnmAddressTypeSelectOption';
import { createKnmDelegateTypeSelectOption } from '../common/createKnmDelegateTypeSelectOption';
import { createKnmDocumentTypeSelectOption } from '../common/createKnmDocumentTypeSelectOption';
import { createKnmExecutionTypeSelectOption } from '../common/createKnmExecutionTypeSelectOption';
import { createKnmInspectorTypeSelectOption } from '../common/createKnmInspectorTypeSelectOption';
import { createKnmLinkTypeSelectOption } from '../common/createKnmLinkTypeSelectOption';
import { createKnmNotificationMethodSelectOption } from '../common/createKnmNotificationMethodSelectOption';
import { createKnmObjectTypeSelectOption } from '../common/createKnmObjectTypeSelectOption';
import {
  createKnmConditionSelectOption,
  createKnmReasonTypeSelectOption,
} from '../common/createKnmReasonTypeSelectOption';
import { createKnmRejectReasonTypeSelectOption } from '../common/createKnmRejectReasonTypeSelectOption';
import { createKnmResultInfoTypeSelectOption } from '../common/createKnmResultInfoTypeSelectOption';
import { createKnmSubjectTypeSelectOption } from '../common/createKnmSubjectTypeSelectOption';
import { createKnmResponsibleTypeSelectOption } from '../common/createKnmResponsibleTypeSelectOption';
import {
  createKnmSupervisionTypeExtendedSelectOption,
  createKnmSupervisionTypeSelectOption,
} from '../common/createKnmSupervisionTypeSelectOption';
import { createKnmTypeSelectOption } from '../common/createKnmTypeSelectOption';
import { createKnmViolationTypeSelectOption } from '../common/createKnmViolationTypeSelectOption';
import { createKnmYearSelectOption } from '../common/createKnmYearSelectOption';
import { createRiskCategorySelectOption } from '../common/createRiskCategorySelectOption';
import { createTestPurchaseMethodSelectOption } from '../common/createTestPurchaseMethodSelectOption';
import { createViolationLawsuitTypeSelectOption } from '../common/createViolationLawsuitTypeSelectOption';
import { createKnmPlanTypeSelectOption } from '../common/createKnmPlanTypeSelectOption';
import { createUserOrganisationSelectOption } from '../common/createUserOrganisationSelectOption';
import { createFederalLawsSelectOption } from '../common/createFederalLawsSelectOption';
import { createKnmPlanReasonChangeTypeSelectOption } from '../common/createKnmPlanReasonChangeTypeSelectOption';
import { createAcquaintanceTypeSelectOption } from '../common/createAcquaintanceTypeSelectOption';
import { createResponsibilityTypeSelectOption } from '../common/createResponsibilityTypeSelectOption';
import { createKindResultDecisionSelectOption } from '../common/createKindResultDecisionSelectOption';
import { createMspCategorySelectOption } from '../common/createMspCategorySelectOption';
import { createListTypeSelectOption } from '../common/createListTypeSelectOption';
import { createTerritoryUnitsSelectOption } from '../common/createTerritoryUnitsSelectOption';
import { createAnalyticsTerritoryUnitsSelectOption } from '../common/createAnalyticsTerritoryUnitsSelectOption';
import { createSupervisionTypesSelectOption } from '../common/createSupervisionTypesSelectOption';
import { createChecklistFullnessTypesSelectOption } from '../common/createChecklistFullnessTypesSelectOption';
import { createRegisterTypesSelectOption } from '../common/createRegisterTypesSelectOption';
import { createKnmStatusesOption } from '../common/createKnmStatusesOption';
import { createKnoAdminLevelSelectOption } from '../common/createKnoAdminLevelSelectOption';
import { createRolesSelectOption } from '../common/createRolesSelectOption';
import { IRegisterTypeSelectOption } from '../interfaces/IRegistryTypeSelectOption';
import { createKnmExclusionReasonSelectOption } from '../common/createKnmExclusionReasonSelectOption';
import { IKnmTypeSelectOption } from '../interfaces/IKnmTypeSelectOption';
import { IUserOrganisationSelectOption } from '../interfaces/IUserOrganisationSelectOption';
import { IKnmReasonChangeTypeSelectOption } from '../interfaces/IKnmReasonChangeTypeSelectOption';
import { IKnmExclusionReasonSelectOption } from '../interfaces/IKnmExclusionReasonSelectOption';
import { IKnmDocumentTypeSelectOption } from '../interfaces/IKnmDocumentTypeSelectOption';
import { createKnmInspectorSelectOption } from '../common/createKnmInspectorSelectOption';
import { createKnmErpStatusesOption } from '../common/createKnmErpStatusesOption';
import { ITerritorialUnitSelectOption } from '../interfaces/ITerritorialUnitSelectOption';
import { IAnalyticsTerritorialUnitSelectOption } from '../interfaces/IAnalyticsTerritorialUnitSelectOption';
import { IFederalLawSelectOption } from '../interfaces/IFederalLawSelectOption';
import { IKnmStatusSelectOption } from '../interfaces/IKnmStatusSelectOption';
import { createKnmActTypeSelectOption } from '../common/createKnmActTypeSelectOption';
import { IKnmActTypeSelectOption } from '../interfaces/IKnmActTypeSelectOption';
import { IKnmCanceledReasonSelectOption } from '../interfaces/IKnmCancelledReasonsSelectOption';
import { createKnmCanceledReasonSelectOption } from '../common/createKnmCanceledReasonSelectOption';
import { createCountrySelectOption } from '../common/createCountriesSelectOption';
import { createGenericReasonSelectOption } from '../common/createGenericReasonSelectOption';
import { createMandatoryCategorySelectOption } from '../common/createMandatoryCategorySelectOption';
import { createInteractionCategorySelectOption } from '../common/createInteractionCategorySelectOption';
import { IInteractionCategorySelectOption } from '../interfaces/IInteractionCategorySelectOption';
import { createPmFormConductingSelectOption } from '../common/createPmFormConductingSelectOption';
import { createJudgmentKindSelectOption } from '../common/createJudgmentKindSelectOption';
import { createJudgmentCourtSelectOption } from '../common/createJudgmentCourtSelectOption';
import { createJudgmentCourtLevelSelectOption } from '../common/createJudgmentCourtLevelSelectOption';
import { createJudgmentProsecutionTypeSelectOption } from '../common/createJudgmentProsecutionTypeSelectOption';
import { createJudgmentPunishmentTypeSelectOption } from '../common/createJudgmentPunishmentTypeSelectOption';
import { createJudgmentPunishmentIndexSelectOption } from '../common/createJudgmentPunishmentIndexSelectOption';
import { createDistrictSelectOption } from '../common/createDistrictSelectOption';
import { IKnmJudgmentCourtLevelSelectOption } from '../interfaces/IKnmJudgmentCourtLevelSelectOption';
import { IKnmJudgmentCourtSelectOption } from '../interfaces/IKnmJudgmentCourtSelectOption';
import { IKnmDistrictSelectOption } from '../interfaces/IKnmDistrictSelectOption';
import { createJudgmentCancellationInfoSelectOption } from '../common/createJudgmentCancellationInfoSelectOption';
import { IKnmJudgmentCancellationInfoSelectOption } from '../interfaces/IKnmJudgmentCancellationInfoSelectOption';
import { IKnmJudgmentPunishmentIndexSelectOption } from '../interfaces/IKnmJudgmentPunishmentIndexSelectOption';
import { createKnmAccessLevelSelectOption } from '../common/createKnmAccessLevelSelectOption';
import { IKnmAccessLevelSelectOption } from '../interfaces/IKnmAccessLevelSelectOption';
import { createPmCanceledReasonSelectOption } from '../common/createPmCanceledReasonSelectOption';
import { createAcquaintanceLackTypeSelectOption } from '../common/createAcquaintanceLackTypeSelectOption';
import { createKnmReasonCancelledSelectOption } from '../common/createKnmReasonCancelledSelectOption';
import { createSubmittedDocumentsStatusTypeSelectOption } from '../common/createSubmittedDocumentsStatusTypeSelectOption';
import { createKnmAbrogationReasonSelectOption } from '../common/createKnmAbrogationReasonSelectOption';
import { IKnmAbrogationReasonSelectOption } from '../interfaces/IKnmAbrogationReasonSelectOption';
import {
  getPlanDataKnoOrganizationDictVersionId,
  getPlanDataSupervisionDictVersionId,
} from '../../../PlanPackage/MainModule/selectors/planSelectors';
import { ICountrySelectOption } from '../interfaces/ICountrySelectOption';
import { IPmCanceledReasonSelectOption } from '../interfaces/IPmCanceledReasonSelectOption';
import { createProsecutorOrganizationsSelectOption } from '../common/createProsecutorOrganizationsSelectOption';
import { IProsecutorOrganizationsSelectOption } from '../interfaces/IProsecutorOrganizationsSelectOption';
import { createKnoLevelSelectOption } from '../common/createKnoLevelSelectOption';
import { createKnmRemarkSelectOption } from '../common/createKnmRemarkSelectOption';
import { IKnmRemarkSelectOption } from '../interfaces/IKnmRemarkSelectOption';
import { createPassportMassCancelReasonSelectOption } from '../common/createPassportMassCancelReasonSelectOption';
import { ISelectOption } from '../../../UIPackage/MainModule/components/SelectInput';
import { createPassportMassDeleteReasonSelectOption } from '../common/createPassportMassDeleteReasonSelectOption';
import { createErvkOrderSelectOption } from '../common/createErvkOrderSelectOption';
import { ICatalog } from '../interfaces/ICatalog';
import { CatalogStatusesEnum } from '../enums/CatalogStatusesEnum';
import { createAgreementChangeReasonSelectOption } from '../common/createAgreementChangeReasonSelectOption';
import { createTerminationReasonSelectOption } from '../common/createTerminationReasonSelectOption';
import { ITerminationReasonSelectOption } from '../interfaces/ITerminationReasonSelectOption';
import { IAgreementChangeReasonSelectOption } from '../interfaces/IAgreementChangeReasonSelectOption';
import { createUavTypeSelectOption } from '../common/createUavTypeSelectOption';
import { getLawInterface } from '../../MainModule/reducers/coreReducer';
import { LawInterfacesEnum } from '../../MainModule/enums/LawInterfacesEnum';

type MakeGetCatalogDataType = <C extends keyof ICommonCatalogsState>(
  catalogName: C,
) => (state: IRootState) => ICommonCatalogsState[C]['data'];

interface IKnmSupervisionTypesByKnmTypeAndSubjectTypeParams {
  knmTypeId: IFetchKnmSupervisionTypesByKnmTypeAndSubjectType['knmTypeId'] | undefined;
  subjectTypeId: IFetchKnmSupervisionTypesByKnmTypeAndSubjectType['subjectTypeId'] | undefined;
}

export interface IKnmTypes248Params {
  knoVersionId?: string;
  supervisionVersionId?: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createSelectOptionMap: Record<keyof ICommonCatalogsState, (props: any) => any> = {
  [CommonCatalogsNamesEnum.CHECKLIST_ANSWER_TYPES]: createChecklistAnswerTypeSelectOption,
  [CommonCatalogsNamesEnum.ERKNM_KNM_EXPERT_TYPES]: createKnmExpertTypeSelectOption,
  [CommonCatalogsNamesEnum.KNM_ADDRESS_TYPES]: createKnmAddressTypeSelectOption,
  [CommonCatalogsNamesEnum.KNM_DELEGATE_TYPES]: createKnmDelegateTypeSelectOption,
  [CommonCatalogsNamesEnum.KNM_REASONS_CANCELED]: createKnmReasonCancelledSelectOption,
  [CommonCatalogsNamesEnum.KNM_DOCUMENT_TYPES]: createKnmDocumentTypeSelectOption,
  [CommonCatalogsNamesEnum.ERKNM_KNM_DOCUMENT_TYPES]: createKnmDocumentTypeSelectOption,
  [CommonCatalogsNamesEnum.DECISION_DOCUMENT_TYPES]: createKnmDocumentTypeSelectOption,
  [CommonCatalogsNamesEnum.KNM_EXECUTION_TYPES]: createKnmExecutionTypeSelectOption,
  [CommonCatalogsNamesEnum.KNM_EXECUTION_TYPES_ALL]: () => {},
  [CommonCatalogsNamesEnum.ROLES]: createRolesSelectOption,
  [CommonCatalogsNamesEnum.KNM_INSPECTORS]: createKnmInspectorSelectOption,
  [CommonCatalogsNamesEnum.KNM_INSPECTOR_TYPES]: createKnmInspectorTypeSelectOption,
  [CommonCatalogsNamesEnum.KNM_LINK_TYPES]: createKnmLinkTypeSelectOption,
  [CommonCatalogsNamesEnum.KNM_NOTICE_METHODS]: createKnmNotificationMethodSelectOption,
  [CommonCatalogsNamesEnum.KNM_NOTICE_METHODS_ALL]: () => {},
  [CommonCatalogsNamesEnum.KNM_OBJECT_TYPES]: createKnmObjectTypeSelectOption,
  [CommonCatalogsNamesEnum.LIST_TYPES]: createListTypeSelectOption,
  [CommonCatalogsNamesEnum.KNO_ADMIN_LEVELS]: createKnoAdminLevelSelectOption,
  [CommonCatalogsNamesEnum.KNM_RESULT_INFO_TYPES]: createKnmResultInfoTypeSelectOption,
  [CommonCatalogsNamesEnum.KNM_SUBJECT_TYPES]: createKnmSubjectTypeSelectOption,
  [CommonCatalogsNamesEnum.KNM_RESPONSIBLE_TYPES]: createKnmResponsibleTypeSelectOption,
  [CommonCatalogsNamesEnum.KNM_TYPES_CANCELED]: createKnmAbrogationReasonSelectOption,
  [CommonCatalogsNamesEnum.KNM_TYPES_294]: createKnmTypeSelectOption,
  [CommonCatalogsNamesEnum.KNM_STATUSES_248]: createKnmStatusesOption,
  [CommonCatalogsNamesEnum.KNM_STATUSES_294]: createKnmStatusesOption,
  [CommonCatalogsNamesEnum.PM_STATUSES]: createKnmStatusesOption,
  [CommonCatalogsNamesEnum.DECISION_STATUSES]: createKnmStatusesOption,
  [CommonCatalogsNamesEnum.KNM_SUBJECT_TYPES_ALL]: () => {},
  [CommonCatalogsNamesEnum.KNM_TYPES_ALL]: () => {},
  [CommonCatalogsNamesEnum.KNM_KINDS_ALL]: () => {},
  [CommonCatalogsNamesEnum.KNM_VIOLATION_TYPES]: createKnmViolationTypeSelectOption,
  [CommonCatalogsNamesEnum.KNM_VIOLATION_TYPES_ALL]: () => {},
  [CommonCatalogsNamesEnum.KNM_YEARS]: createKnmYearSelectOption,
  [CommonCatalogsNamesEnum.RISK_CATEGORIES]: createRiskCategorySelectOption,
  [CommonCatalogsNamesEnum.TEST_PURCHASE_METHODS]: createTestPurchaseMethodSelectOption,
  [CommonCatalogsNamesEnum.VIOLATION_LAWSUIT_TYPES]: createViolationLawsuitTypeSelectOption,
  [CommonCatalogsNamesEnum.KNM_PLAN_TYPES]: createKnmPlanTypeSelectOption,
  [CommonCatalogsNamesEnum.USER_KNOS]: createUserOrganisationSelectOption,
  [CommonCatalogsNamesEnum.USER_PROSECUTORS]: createUserOrganisationSelectOption,
  [CommonCatalogsNamesEnum.FEDERAL_LAWS_248]: createFederalLawsSelectOption,
  [CommonCatalogsNamesEnum.FEDERAL_LAWS_294]: createFederalLawsSelectOption,
  [CommonCatalogsNamesEnum.SUPERVISION_TYPES]: createSupervisionTypesSelectOption,
  [CommonCatalogsNamesEnum.CHECKLIST_FULLNESS_TYPES]: createChecklistFullnessTypesSelectOption,
  [CommonCatalogsNamesEnum.REGISTER_TYPES]: createRegisterTypesSelectOption,
  [CommonCatalogsNamesEnum.RESPONSIBILITY_TYPES]: createResponsibilityTypeSelectOption,
  [CommonCatalogsNamesEnum.KNM_PLAN_REASON_CHANGE_TYPES]: createKnmPlanReasonChangeTypeSelectOption,
  [CommonCatalogsNamesEnum.KNM_EXCLUSION_REASONS]: createKnmExclusionReasonSelectOption,
  [CommonCatalogsNamesEnum.ERKNM_ACQUAINTANCE_TYPES]: createAcquaintanceTypeSelectOption,
  [CommonCatalogsNamesEnum.ERKNM_ACQUAINTANCE_LACK_TYPES]: createAcquaintanceLackTypeSelectOption,
  [CommonCatalogsNamesEnum.ERKNM_SUBMITTED_DOCUMENTS_STATUS]: createSubmittedDocumentsStatusTypeSelectOption,
  [CommonCatalogsNamesEnum.ERKNM_KIND_RESULT_DECISION]: createKindResultDecisionSelectOption,
  [CommonCatalogsNamesEnum.MSP_CATEGORIES]: createMspCategorySelectOption,
  [CommonCatalogsNamesEnum.TERRITORIAL_UNITS]: createTerritoryUnitsSelectOption,
  [CommonCatalogsNamesEnum.TERRITORIAL_UNITS_BY_LEVELS_COUNTRY_FEDERAL_DISTRICTS_REGIONS]: createTerritoryUnitsSelectOption,
  [CommonCatalogsNamesEnum.PROSECUTOR_ORGANIZATIONS]: createProsecutorOrganizationsSelectOption,
  [CommonCatalogsNamesEnum.ANALYTICS_TERRITORIAL_UNITS]: createAnalyticsTerritoryUnitsSelectOption,
  [CommonCatalogsNamesEnum.KNM_ACT_TYPES]: createKnmActTypeSelectOption,
  [CommonCatalogsNamesEnum.PM_PROF_ACT_TYPES]: createKnmActTypeSelectOption,
  [CommonCatalogsNamesEnum.KNM_CANCELED_REASONS]: createKnmCanceledReasonSelectOption,
  [CommonCatalogsNamesEnum.COUNTRIES]: createCountrySelectOption,
  [CommonCatalogsNamesEnum.GENERIC_REASONS]: createGenericReasonSelectOption,
  [CommonCatalogsNamesEnum.DECISION_GENERIC_REASONS]: createGenericReasonSelectOption,
  [CommonCatalogsNamesEnum.MANDATORY_CATEGORIES]: createMandatoryCategorySelectOption,
  [CommonCatalogsNamesEnum.INTERACTION_CATEGORIES]: createInteractionCategorySelectOption,
  [CommonCatalogsNamesEnum.PM_FORMS_CONDUCTING]: createPmFormConductingSelectOption,
  [CommonCatalogsNamesEnum.JUDGMENT_COURT_LEVELS]: createJudgmentCourtLevelSelectOption,
  [CommonCatalogsNamesEnum.JUDGMENT_KINDS]: createJudgmentKindSelectOption,
  [CommonCatalogsNamesEnum.JUDGMENT_COURTS]: createJudgmentCourtSelectOption,
  [CommonCatalogsNamesEnum.JUDGMENT_PROSECUTION_TYPES]: createJudgmentProsecutionTypeSelectOption,
  [CommonCatalogsNamesEnum.JUDGMENT_PUNISHMENT_TYPES]: createJudgmentPunishmentTypeSelectOption,
  [CommonCatalogsNamesEnum.JUDGMENT_PUNISHMENT_INDEX]: createJudgmentPunishmentIndexSelectOption,
  [CommonCatalogsNamesEnum.JUDGMENT_CANCELLATION_INFORMATION]: createJudgmentCancellationInfoSelectOption,
  [CommonCatalogsNamesEnum.DISTRICTS]: createDistrictSelectOption,
  [CommonCatalogsNamesEnum.KNM_ACCESS_LEVELS]: createKnmAccessLevelSelectOption,
  [CommonCatalogsNamesEnum.PM_CANCELED_REASONS]: createPmCanceledReasonSelectOption,
  [CommonCatalogsNamesEnum.VIOLATION_MATERIAL_TYPE]: createViolationMaterialTypeSelectOption,
  [CommonCatalogsNamesEnum.VIOLATION_FIX_METHOD]: createViolationFixMethodSelectOption,
  [CommonCatalogsNamesEnum.VIOLATION_FIX_GRADE]: createViolationFixGradeSelectOption,
  [CommonCatalogsNamesEnum.KNO_LEVELS]: createKnoLevelSelectOption,
  [CommonCatalogsNamesEnum.KNM_REMARKS]: createKnmRemarkSelectOption,
  [CommonCatalogsNamesEnum.KNM_REMARKS_ALL]: createKnmRemarkSelectOption,
  [CommonCatalogsNamesEnum.PASSPORT_MASS_CANCEL_REASON]: createPassportMassCancelReasonSelectOption,
  [CommonCatalogsNamesEnum.PASSPORT_MASS_DELETE_REASON]: createPassportMassDeleteReasonSelectOption,
  [CommonCatalogsNamesEnum.ERVK_ORDERS]: createErvkOrderSelectOption,
  [CommonCatalogsNamesEnum.AGREEMENT_CHANGE_REASON]: createAgreementChangeReasonSelectOption,
  [CommonCatalogsNamesEnum.TERMINATION_REASONS]: createTerminationReasonSelectOption,
  [CommonCatalogsNamesEnum.UAV_TYPES]: createUavTypeSelectOption,
};
export const getCatalogsState = (state: IRootState) => state?.catalogs;
export const makeGetCatalogData: MakeGetCatalogDataType = catalogName => state => state.catalogs[catalogName].data;
export const makeGetCatalogStatus = (catalogName: CommonCatalogsNamesEnum) => (state: IRootState) =>
  state.catalogs[catalogName].status;
export const makeGetCatalogSelectOptions = <C extends keyof ICommonCatalogsState>(catalogName: C) =>
  createSelector(makeGetCatalogData(catalogName), (dataItems: ICommonCatalogsState[C]['data']) =>
    Array.isArray(dataItems)
      ? dataItems.map((dataItem: ICommonCatalogsState[C]['data'][number]) =>
          createSelectOptionMap[catalogName](dataItem),
        )
      : [],
  );

export const getChecklistAnswerTypesSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.CHECKLIST_ANSWER_TYPES,
);
export const getCatalogsErknmKnmExpertTypesSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.ERKNM_KNM_EXPERT_TYPES,
);

export const geCatalogsKnmPlanReasonChangeTypesSelectOptions: (
  state: IRootState,
) => IKnmReasonChangeTypeSelectOption[] = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.KNM_PLAN_REASON_CHANGE_TYPES,
);

export const geCatalogsAgreementChangeReasonSelectOptions: (
  state: IRootState,
) => IAgreementChangeReasonSelectOption[] = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.AGREEMENT_CHANGE_REASON,
);

export const getCatalogsKnmExclusionReasonsSelectOptions: (
  state: IRootState,
) => IKnmExclusionReasonSelectOption[] = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.KNM_EXCLUSION_REASONS);

export const geCatalogsResponsibilityTypesSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.RESPONSIBILITY_TYPES,
);
export const getCatalogKnmReasonsCanceled = (state: IRootState) => state.catalogs.KNM_REASONS_CANCELED.data;
export const getCatalogKnmReasonsCancelledSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.KNM_REASONS_CANCELED,
);

export const getCatalogKnmAddressTypes = (state: IRootState) => state.catalogs.KNM_ADDRESS_TYPES.data;
export const getCatalogKnmAddressTypesSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.KNM_ADDRESS_TYPES,
);
export const getCatalogKnmDelegateTypes = (state: IRootState) => state.catalogs.KNM_DELEGATE_TYPES.data;
export const getCatalogKnmDelegateTypesSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.KNM_DELEGATE_TYPES,
);

export const getCatalogKnmDocumentTypesSelectOptions: (
  state: IRootState,
) => IKnmDocumentTypeSelectOption[] = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.KNM_DOCUMENT_TYPES);

export const getCatalogErknmKnmDocumentTypesSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.ERKNM_KNM_DOCUMENT_TYPES,
);
export const getCatalogDecisionDocumentTypesSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.DECISION_DOCUMENT_TYPES,
);
export const getCatalogKnmExecutionTypesSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.KNM_EXECUTION_TYPES,
);
export const getCatalogKnmExecutionTypesAll = (state: IRootState) => state.catalogs.KNM_EXECUTION_TYPES_ALL.data;
export const getCatalogRolesSelectOptions: (state: IRootState) => IRolesSelectOption[] = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.ROLES,
);
export const getCatalogKnmInspectors = makeGetCatalogData(CommonCatalogsNamesEnum.KNM_INSPECTORS);
export const getCatalogKnmInspectorSelectOptions = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.KNM_INSPECTORS);
export const getCatalogKnmInspectorsStatus = makeGetCatalogStatus(CommonCatalogsNamesEnum.KNM_INSPECTORS);
export const getCatalogKnmInspectorTypes = (state: IRootState) => state.catalogs.KNM_INSPECTOR_TYPES.data;
export const getCatalogKnmInspectorTypesSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.KNM_INSPECTOR_TYPES,
);
export const getCatalogKnmLinkTypesSelectOptions = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.KNM_LINK_TYPES);
export const getCatalogKnmNoticeMethodsAll = (state: IRootState) => state.catalogs.KNM_NOTICE_METHODS_ALL.data;
export const getCatalogKnmNoticeMethodsSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.KNM_NOTICE_METHODS,
);
export const getCatalogKnmObjectTypesSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.KNM_OBJECT_TYPES,
);
export const getCatalogListTypes = (state: IRootState) => state.catalogs.LIST_TYPES.data;
export const getCatalogListTypesSelectOptions = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.LIST_TYPES);
export const getCatalogKnoAdminLevels = (state: IRootState) => state.catalogs.KNO_ADMIN_LEVELS.data;
export const getCatalogKnoAdminLevelsSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.KNO_ADMIN_LEVELS,
);
export const getCatalogKnmReasonTypes = (state: IRootState, knmTypeId: number | undefined) => {
  return state.catalogs[ComplexCatalogsNamesEnum.KNM_REASON_TYPES][`${knmTypeId}`]?.data;
};
export const getCatalogKnmReasonTypesStatus = (state: IRootState, knmTypeId: number | undefined) => {
  return state.catalogs[ComplexCatalogsNamesEnum.KNM_REASON_TYPES][`${knmTypeId}`]?.status;
};
export const getCatalogKnmErpConditionsStatus = (
  state: IRootState,
  knmTypeCode: string | undefined,
  knoVersionId: string | undefined,
  supervisionVersionId: string | undefined,
  knmKindId: string | undefined,
) => {
  return state.catalogs[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS][
    `${knoVersionId}${supervisionVersionId}${knmTypeCode}${knmKindId}`
  ]?.status;
};
export const getCatalogKnmErpConditions = (
  state: IRootState,
  knmTypeCode: string | undefined,
  knoVersionId: string | undefined,
  knmKindId: string | undefined,
  supervisionVersionId: string | undefined,
  isComplete336Available: boolean | undefined,
) => {
  const knmConditions: IKnmReasonTypeExtended[] | undefined =
    state.catalogs[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS][
      `${knoVersionId}${supervisionVersionId}${knmTypeCode}${knmKindId}`
    ]?.data;

  return isComplete336Available ? knmConditions : knmConditions?.filter(item => item.code !== 'PM_5');
};
export const makeGetCatalogKnmReasonTypesSelectOptions = () => {
  return createSelector(getCatalogKnmReasonTypes, knmReasonTypes =>
    knmReasonTypes?.map(item => createKnmReasonTypeSelectOption(item)),
  );
};
export const makeGetCatalogKnmConditionsSelectOptions = () => {
  return createSelector(getCatalogKnmReasonTypes, knmReasonTypes =>
    knmReasonTypes?.map(item => createKnmConditionSelectOption(item)),
  );
};
export const makeGetCatalogKnmErpStatusesSelectOptions = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return createSelector(makeGetCatalogData(CommonCatalogsNamesEnum.KNM_STATUSES_294), (knmStatuses: any[]) =>
    excludeGeneralOptions(knmStatuses.map((item: IKnmStatus) => createKnmErpStatusesOption(item, knmStatuses))),
  );
};
export const makeGetCatalogKnmErpConditionsSelectOptions = () => {
  return createSelector(getCatalogKnmErpConditions, knmCondition =>
    knmCondition?.map(item => createKnmConditionSelectOption(item)),
  );
};

export const getCatalogKnmRejectReasonTypes = (state: IRootState, knmTypeId: number | undefined) => {
  return state.catalogs[ComplexCatalogsNamesEnum.KNM_REJECT_REASON_TYPES][`${knmTypeId}`]?.data;
};
export const getCatalogKnmRejectReasonTypesStatus = (state: IRootState, knmTypeId: number | undefined) => {
  return state.catalogs[ComplexCatalogsNamesEnum.KNM_REJECT_REASON_TYPES][`${knmTypeId}`]?.status;
};
export const makeGetCatalogKnmRejectReasonTypesSelectOptions = () => {
  return createSelector(getCatalogKnmRejectReasonTypes, knmRejectReasonTypes =>
    knmRejectReasonTypes?.map(item => createKnmRejectReasonTypeSelectOption(item)),
  );
};

export const getCatalogErknmKnmRejectReasonTypes = (state: IRootState, isPlaned: boolean | undefined) => {
  return state.catalogs[ComplexCatalogsNamesEnum.ERKNM_KNM_REJECT_REASON_TYPES][`${isPlaned}`]?.data;
};
export const getCatalogErknmKnmRejectReasonTypesStatus = (state: IRootState, isPlaned: boolean | undefined) => {
  return state.catalogs[ComplexCatalogsNamesEnum.ERKNM_KNM_REJECT_REASON_TYPES][`${isPlaned}`]?.status;
};
export const makeGetCatalogErknmKnmRejectReasonTypesSelectOptions = () => {
  return createSelector(getCatalogErknmKnmRejectReasonTypes, knmRejectReasonTypes =>
    knmRejectReasonTypes?.map(item => createKnmRejectReasonTypeSelectOption(item)),
  );
};

export const getCatalogErknmKnmConditions = (
  state: IRootState,
  knoVersionId: string | undefined,
  supervisionVersionId: string | undefined,
  erknmTypeCode: string | undefined,
  isComplete336Available: boolean | undefined,
  knmKindId: string | undefined,
) => {
  const knmConditions: IKnmReasonTypeExtended[] | undefined =
    state.catalogs[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS][
      `${knoVersionId}${supervisionVersionId}${erknmTypeCode}${knmKindId}`
    ]?.data;

  return isComplete336Available ? knmConditions : knmConditions?.filter(item => item.code !== 'PM_5');
};
export const getCatalogErknmKnmConditionsStatus = (
  state: IRootState,
  knoVersionId: string | undefined,
  supervisionVersionId: string | undefined,
  erknmTypeCode: string | undefined,
  knmKindId: string | undefined,
) => {
  return state.catalogs[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS][
    `${knoVersionId}${supervisionVersionId}${erknmTypeCode}${knmKindId}`
  ]?.status;
};
export const getCatalogErknmKnmConditionsSelectOptions = (
  state: IRootState,
  knoVersionId: string | undefined,
  supervisionVersionId: string | undefined,
  erknmTypeCode: string | undefined,
  isComplete336Available: boolean | undefined,
  knmKindId: string | undefined,
) => {
  const knmConditions = getCatalogErknmKnmConditions(
    state,
    knoVersionId,
    supervisionVersionId,
    erknmTypeCode,
    isComplete336Available,
    knmKindId,
  );

  return knmConditions?.map(item => createKnmConditionSelectOption(item));
};
export const getCatalogErknmKnmReasonTypesSelectOptionsSelector = (state: IRootState) => (
  knoVersionId: string | undefined,
  supervisionVersionId: string | undefined,
  erknmTypeCode: string | undefined,
  knmCreated: string | null | undefined,
  knmKindId: string | undefined,
) => {
  const isComplete336Available = !knmCreated
    ? new Date().getFullYear() >= 2022 && new Date().getFullYear() <= 2024
    : new Date(knmCreated).getFullYear() >= 2022 && new Date(knmCreated).getFullYear() <= 2024;

  return getCatalogErknmKnmConditionsSelectOptions(
    state,
    knoVersionId,
    supervisionVersionId,
    erknmTypeCode,
    isComplete336Available,
    knmKindId,
  );
};

export const getCatalogPmConditions = (
  state: IRootState,
  knoVersionId: string | undefined,
  supervisionVersionId: string | undefined,
  isComplete336Available: boolean | undefined,
  profKindId: string | undefined,
  federalLawId: string | undefined,
) => {
  const knmConditions: IKnmReasonTypeExtended[] | undefined =
    state.catalogs[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS][
      `${knoVersionId}${supervisionVersionId}${profKindId}${federalLawId}`
    ]?.data;

  return isComplete336Available ? knmConditions : knmConditions?.filter(item => item.code !== 'PM_5');
};
export const getCatalogPmConditionsStatus = (
  state: IRootState,
  knoVersionId: string | undefined,
  supervisionVersionId: string | undefined,
  profKindId: string | undefined,
  uuidFederalLaw: string | undefined,
) => {
  return state.catalogs[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS][
    `${knoVersionId}${supervisionVersionId}${profKindId}${uuidFederalLaw}`
  ]?.status;
};
export const getCatalogDecisionConditions = (
  state: IRootState,
  knoVersionId: string | undefined,
  supervisionVersionId: string | undefined,
  decisionKindId: string | undefined,
) => {
  return state.catalogs[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS][
    `${knoVersionId}${supervisionVersionId}${decisionKindId}`
  ]?.data;
};
export const getCatalogErknmDecisionConditionsStatus = (
  state: IRootState,
  knoVersionId: string | undefined,
  supervisionVersionId: string | undefined,
  decisionKindId: string | undefined,
) => {
  return state.catalogs[ComplexCatalogsNamesEnum.ERKNM_KNM_CONDITIONS][
    `${knoVersionId}${supervisionVersionId}${decisionKindId}`
  ]?.status;
};
export const makeGetCatalogPmConditionsSelectOptions = () => {
  return createSelector(getCatalogPmConditions, knmConditions =>
    knmConditions?.map(item => createKnmConditionSelectOption(item)),
  );
};
export const makeGetCatalogDecisionConditionsSelectOptions = () => {
  return createSelector(getCatalogDecisionConditions, knmConditions =>
    knmConditions?.map(item => createKnmConditionSelectOption(item)),
  );
};

export const getCatalogKnmResultInfoTypes = makeGetCatalogData(CommonCatalogsNamesEnum.KNM_RESULT_INFO_TYPES);
export const getCatalogKnmResultInfoTypesSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.KNM_RESULT_INFO_TYPES,
);
export const getCatalogKnmSubjectTypes = makeGetCatalogData(CommonCatalogsNamesEnum.KNM_SUBJECT_TYPES_ALL);
export const getCatalogKnmSubjectTypesSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.KNM_SUBJECT_TYPES,
);
export const getCatalogKnmResponsibleTypesSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.KNM_RESPONSIBLE_TYPES,
);
export const getCatalogKnmSupervisionTypesByKnmTypeAndSubjectType = (
  state: IRootState,
  params: IKnmSupervisionTypesByKnmTypeAndSubjectTypeParams,
) => {
  return state.catalogs[ComplexCatalogsNamesEnum.KNM_SUPERVISION_TYPES_BY_KNM_TYPE_AND_SUBJECT_TYPE][
    `${params.knmTypeId}/${params.subjectTypeId}`
  ]?.data;
};
export const getCatalogKnmSupervisionTypesByKnmTypeAndSubjectTypeStatus = (
  state: IRootState,
  params: IKnmSupervisionTypesByKnmTypeAndSubjectTypeParams,
) => {
  return state.catalogs[ComplexCatalogsNamesEnum.KNM_SUPERVISION_TYPES_BY_KNM_TYPE_AND_SUBJECT_TYPE][
    `${params.knmTypeId}/${params.subjectTypeId}`
  ]?.status;
};
export const makeGetCatalogKnmSupervisionTypesSelectOptions = () => {
  return createSelector(getCatalogKnmSupervisionTypesByKnmTypeAndSubjectType, supervisionTypes =>
    supervisionTypes?.map(item => createKnmSupervisionTypeSelectOption(item)),
  );
};
export const makeGetCatalogKnmSupervisionTypesExtendedSelectOptions = () => {
  return createSelector(getCatalogKnmSupervisionTypesByKnmTypeAndSubjectType, supervisionTypes =>
    supervisionTypes?.map(item => createKnmSupervisionTypeExtendedSelectOption(item)),
  );
};
export const getCatalogKnmTypesCancelledSelectOptions: (
  state: IRootState,
) => IKnmAbrogationReasonSelectOption[] = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.KNM_TYPES_CANCELED);

export const getCatalogKnmTypes248 = (state: IRootState, params: IKnmTypes248Params) => {
  const groupKey = `${params.knoVersionId}/${params.supervisionVersionId}`;

  return state.catalogs[ComplexCatalogsNamesEnum.KNM_TYPES_248][groupKey]?.data;
};
export const getCatalogKnmTypes248Status = (state: IRootState, params: IKnmTypes248Params) => {
  const groupKey = `${params.knoVersionId}/${params.supervisionVersionId}`;

  return state.catalogs[ComplexCatalogsNamesEnum.KNM_TYPES_248][groupKey]?.status;
};
export const getCatalogKnmTypes248SelectOptionsSelector = (state: IRootState) => (
  params: IKnmTypes248Params,
): IKnmTypeSelectOption[] => {
  return getCatalogKnmTypes248(state, params)?.map(createKnmTypeSelectOption) || [];
};

export const getCatalogKnmTypes294SelectOptions: (
  state: IRootState,
) => IKnmTypeSelectOption[] = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.KNM_TYPES_294);

export const getCatalogKnmStatuses248SelectOptions: (
  state: IRootState,
) => IKnmStatusSelectOption[] = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.KNM_STATUSES_248);

export const makeGetCatalogKnmStatuses294SelectOptions = () =>
  createSelector(
    makeGetCatalogData(CommonCatalogsNamesEnum.KNM_STATUSES_294),
    (dataItems: ICommonCatalogsState[CommonCatalogsNamesEnum.KNM_STATUSES_294]['data']) =>
      Array.isArray(dataItems)
        ? dataItems.map((dataItem: ICommonCatalogsState[CommonCatalogsNamesEnum.KNM_STATUSES_294]['data'][number]) =>
            createKnmErpStatusesOption(dataItem as IKnmStatus, dataItems as IKnmStatus[]),
          )
        : [],
  );

export const getCatalogKnmStatuses294SelectOptions: (
  state: IRootState,
) => IKnmStatusSelectOption[] = makeGetCatalogKnmStatuses294SelectOptions();

export const getCatalogPmStatusesSelectOptions: (
  state: IRootState,
) => IKnmStatusSelectOption[] = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.PM_STATUSES);

export const getCatalogDecisionStatusesSelectOptions: (
  state: IRootState,
) => IKnmStatusSelectOption[] = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.DECISION_STATUSES);

export const getCatalogCountriesSelectOptions: (
  state: IRootState,
) => ICountrySelectOption[] = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.COUNTRIES);

export const getCatalogTerminationReasonSelectOptions: (
  state: IRootState,
) => ITerminationReasonSelectOption[] = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.TERMINATION_REASONS);

export const getCatalogKnmTypesAll = makeGetCatalogData(CommonCatalogsNamesEnum.KNM_TYPES_ALL);
export const getCatalogKnmKindsAll = makeGetCatalogData(CommonCatalogsNamesEnum.KNM_KINDS_ALL);
export const getCatalogKnmViolationTypesAll = makeGetCatalogData(CommonCatalogsNamesEnum.KNM_VIOLATION_TYPES_ALL);
export const getCatalogKnmViolationTypesSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.KNM_VIOLATION_TYPES,
);

export const getCatalogKnmYearsSelectOptions: (state: IRootState) => IYearSelectOption[] = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.KNM_YEARS,
);

export const getCatalogRiskCategories = makeGetCatalogData(CommonCatalogsNamesEnum.RISK_CATEGORIES);
export const getCatalogRiskCategoriesSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.RISK_CATEGORIES,
);
export const getCatalogRiskCategoriesSelectOptionsErp = (state: IRootState) => {
  const dictionaryName = DictionaryNamesEnum.RISK_CATEGORY;

  return state.dictionaries.items[dictionaryName]?.values || [];
};
export const getCatalogTestPurchaseMethods = makeGetCatalogData(CommonCatalogsNamesEnum.TEST_PURCHASE_METHODS);
export const getCatalogTestPurchaseMethodsSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.TEST_PURCHASE_METHODS,
);
export const getCatalogViolationLawsuitTypesSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.VIOLATION_LAWSUIT_TYPES,
);
export const getKnmPlanTypeSelectOptions = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.KNM_PLAN_TYPES);
export const getUserKnoSelectOptions: (
  state: IRootState,
) => IUserOrganisationSelectOption[] | undefined = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.USER_KNOS);
export const getUserProsecutorSelectOptions: (
  state: IRootState,
) => IUserOrganisationSelectOption[] | undefined = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.USER_PROSECUTORS,
);

export const getFederalLaw248SelectOptions: (
  state: IRootState,
) => IFederalLawSelectOption[] = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.FEDERAL_LAWS_248);

export const getFederalLaw294SelectOptions: (
  state: IRootState,
) => IFederalLawSelectOption[] = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.FEDERAL_LAWS_294);

export const getCatalogsErknmAcquaintanceTypesSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.ERKNM_ACQUAINTANCE_TYPES,
);
export const getCatalogsErknmAcquaintanceLackTypesSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.ERKNM_ACQUAINTANCE_LACK_TYPES,
);
export const getCatalogsErknmSubmittedDocumentsStatusTypeSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.ERKNM_SUBMITTED_DOCUMENTS_STATUS,
);
export const getCatalogsErknmKindResultDecisionSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.ERKNM_KIND_RESULT_DECISION,
);

export const getCatalogsErknmKindResultDecisionStatus = makeGetCatalogStatus(
  CommonCatalogsNamesEnum.ERKNM_KIND_RESULT_DECISION,
);

export const getCatalogsMspCategoriesSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.MSP_CATEGORIES,
);

export const getCatalogsTerritorialUnitsSelectOptions: (
  state: IRootState,
) => ITerritorialUnitSelectOption[] = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.TERRITORIAL_UNITS);

export const getCatalogsTerritorialUnitsSelectOptionsByLevelsCountryFederalDistrictRegions: (
  state: IRootState,
) => ITerritorialUnitSelectOption[] = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.TERRITORIAL_UNITS_BY_LEVELS_COUNTRY_FEDERAL_DISTRICTS_REGIONS,
);

export const getCatalogsProsecutorOrganizationsSelectOptions: (
  state: IRootState,
) => IProsecutorOrganizationsSelectOption[] = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.PROSECUTOR_ORGANIZATIONS,
);

export const makeGetCatalogsSupervisionTypesSelectOptions = () => (state: IRootState, constraintUUIDs: string[]) => {
  const dictionaryData: IDictionarySupervisionTypeSelectOption[] | undefined = getCatalogsSupervisionTypesSelectOptions(
    state,
  );

  if (constraintUUIDs.length === 0) {
    return [];
  }

  return Array.from(dictionaryData.values());
};
export const getCatalogsAnalyticsTerritorialUnitsSelectOptions: (
  state: IRootState,
) => IAnalyticsTerritorialUnitSelectOption[] = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.ANALYTICS_TERRITORIAL_UNITS,
);

export const getCatalogsSupervisionTypesSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.SUPERVISION_TYPES,
);
export const getCatalogsChecklistFullnessTypesSelectOptions = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.CHECKLIST_FULLNESS_TYPES,
);
export const getCatalogsRegisterTypesSelectOptions: (
  state: IRootState,
) => IRegisterTypeSelectOption[] = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.REGISTER_TYPES);

export const getCatalogsKnmActTypesSelectOptions: (
  state: IRootState,
) => IKnmActTypeSelectOption[] = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.KNM_ACT_TYPES);

export const getCatalogsPmProfActTypesSelectOptions: (
  state: IRootState,
) => IKnmActTypeSelectOption[] = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.PM_PROF_ACT_TYPES);

export const getCatalogsKnmCanceledReasonsSelectOptions: (
  state: IRootState,
) => IKnmCanceledReasonSelectOption[] = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.KNM_CANCELED_REASONS);

export const getCatalogsPmCanceledReasonsSelectOptions: (
  state: IRootState,
) => IPmCanceledReasonSelectOption[] = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.PM_CANCELED_REASONS);

export const getJudgmentCourtSelectOptions: (
  state: IRootState,
) => IKnmJudgmentCourtSelectOption[] = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.JUDGMENT_COURTS);

export const getJudgmentPunishmentIndexSelectOptions: (
  state: IRootState,
) => IKnmJudgmentPunishmentIndexSelectOption[] = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.JUDGMENT_PUNISHMENT_INDEX,
);

export const getJudgmentCourtLevelSelectOptions: (
  state: IRootState,
) => IKnmJudgmentCourtLevelSelectOption[] = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.JUDGMENT_COURT_LEVELS);

export const getJudgmentCancellationInfoSelectOptions: (
  state: IRootState,
) => IKnmJudgmentCancellationInfoSelectOption[] = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.JUDGMENT_CANCELLATION_INFORMATION,
);

export const getDistrictSelectOptions: (state: IRootState) => IKnmDistrictSelectOption[] = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.DISTRICTS,
);

export const getPassportMassCancelReasonSelectOptions: (
  state: IRootState,
) => ISelectOption[] = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.PASSPORT_MASS_CANCEL_REASON);

export const getPassportMassDeleteReasonSelectOptions: (
  state: IRootState,
) => ISelectOption[] = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.PASSPORT_MASS_DELETE_REASON);

export const getKnmAccessLevelSelectOptions: (
  state: IRootState,
) => IKnmAccessLevelSelectOption[] = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.KNM_ACCESS_LEVELS);

export const getCatalogsInteractionCategorySelectOptions: (
  state: IRootState,
) => IInteractionCategorySelectOption[] = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.INTERACTION_CATEGORIES);

export const getCatalogOrdersRelationDictionaries = (
  state: IRootState,
  orderId: string | undefined,
  orderVersionId: string | undefined,
) => {
  return state.catalogs[ComplexCatalogsNamesEnum.ORDERS_RELATION_DICTIONARIES][`${orderId}${orderVersionId}`]?.status;
};

export const getKnoOrganizationWithChildren = (state: IRootState, uuidKno: string, uuidSupervision: string) => {
  return state.catalogs[ComplexCatalogsNamesEnum.KNO_ORGANIZATIONS][`${uuidKno}${uuidSupervision}`]?.data;
};

export const makeGetKnoOrganizationWithChildrenOptionsSelector = (state: IRootState) => (
  uuidKno: string,
  uuidSupervision: string,
): IUserOrganisationSelectOption[] => {
  return getKnoOrganizationWithChildren(state, uuidKno, uuidSupervision)?.map(createUserOrganisationSelectOption) || [];
};

export const getKnoOrganizationWithChildrenSelectOptions = (state: IRootState) => {
  const knoOrganizationDictVersionId = getPlanDataKnoOrganizationDictVersionId(state);
  const supervisionTypeDictVersionId = getPlanDataSupervisionDictVersionId(state);

  if (knoOrganizationDictVersionId && supervisionTypeDictVersionId) {
    return makeGetKnoOrganizationWithChildrenOptionsSelector(state)(
      knoOrganizationDictVersionId,
      supervisionTypeDictVersionId,
    );
  }

  return undefined;
};

export const getCountriesSelectOptions: (state: IRootState) => ICountrySelectOption[] = makeGetCatalogSelectOptions(
  CommonCatalogsNamesEnum.COUNTRIES,
);

export const getFnsRegistryOkvedCodes = (state: IRootState, inn: string) =>
  state.catalogs[ComplexCatalogsNamesEnum.FNS_REGISTRY_OKVED_CODES][inn];
export const getFnsRegistryOkvedCodesStatus = (state: IRootState, inn: string) =>
  getFnsRegistryOkvedCodes(state, inn)?.status;

export const getCatalogKnoLevelsSelectOptions = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.KNO_LEVELS);

export const getCatalogKnmRemarkSelectOptions: (
  state: IRootState,
) => IKnmRemarkSelectOption[] = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.KNM_REMARKS);
export const getCatalogKnmRemarksAll = makeGetCatalogData(CommonCatalogsNamesEnum.KNM_REMARKS_ALL);

export const getErvkOrderSelectOptions = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.ERVK_ORDERS);

export const getUavTypeSelectOptions = makeGetCatalogSelectOptions(CommonCatalogsNamesEnum.UAV_TYPES);

export const hasAnyCatalogFailed = (state: IRootState) => {
  if (getLawInterface(state) !== LawInterfacesEnum.FZ_248) {
    return false;
  }

  return Object.values(getCatalogsState(state)).some(entry => {
    if (!entry || typeof entry !== 'object') {
      return false;
    }
    if ('status' in entry) {
      return (entry as ICatalog<unknown>).status === CatalogStatusesEnum.FAILED;
    }

    return Object.values(entry as Record<string, ICatalog<unknown>>).some(
      nested => nested?.status === CatalogStatusesEnum.FAILED,
    );
  });
};
